<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <treeselect v-model="selected" :options="options" :multiple="multiple"
                :auto-load-root-options="autoLoadRootOptions" :load-options="loadOptions"
                :value-consists-of="'LEAF_PRIORITY'" :limit="3" @input="input"
                :noChildrenText="noChildrenText" :noResultsText="noResultsText"
                :noOptionsText="noOptionsText" :placeholder="placeholder"
                :retryText="retryText" :retryTitle="retryTitle" :searchPromptText="searchPromptText"
    ></treeselect>
  </b-form-group>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: "ClientUserTreeSelect",
  components: {Treeselect},
  props: {
    model: Object,
    attribute: {
      type: String,
      default: 'user'
    },
    field: {
      type: String,
      default: '_id'
    },
    autoLoadRootOptions: {
      type: Boolean,
      default: false
    },
    multiple: Boolean,
    label: String,
    clientFilter: String,
    noChildrenText: String,
    noOptionsText: String,
    noResultsText: String,
    placeholder: String,
    retryText: String,
    retryTitle: String,
    searchPromptText: String,
    errors: Array,
  },
  data() {
    return {
      errorTxt: '',
      selected: [],
      state: null,
      options: null,
      client: this.clientFilter
    }
  },
  methods: {
    async loadOptions() {
      this.options = [];
      if (this.client) {
        if (this.multiple) {
          let groups = [{_id: 'default', name: this.$t('default')}];
          let res = await this.$service.get('/client-user-group', {
            params: {
              page: 1,
              pageSize: 100,
              status: 0,
              client: this.client
            }
          })
          if (res && res.data) {
            groups = groups.concat(res.data.docs);
          }
          for (let g of groups) {
            let option = {id: 'group' + g._id, label: g.name, children: []};
            let res2 = await this.$service.get('/client-user', {
              params: {
                page: 1,
                pageSize: 100,
                status: 0,
                group: g._id,
                client: this.client
              }
            })
            if (res2 && res2.data) {
              for (let u of res2.data.docs) {
                option.children.push({id: u[this.field], label: `${u.name} - ${u.ext} - ${u.email}`})
              }
            }
            this.options.push(option);
          }
        } else {
          let response = await this.$service.get('/client-user', {
            params: {
              page: 1,
              pageSize: 100,
              status: 0,
              client: this.client
            }
          })
          if (response && response.data) {
            response.data.docs.forEach(user => {
              this.options.push({id: user[this.field], label: `${user.name} - ${user.ext} - ${user.email}`})
            })
          }
        }
        this.loadSelected();
      }
    },
    input() {
      if (this.selected && this.selected.length) {
        this.model[this.attribute] = this.selected;
      } else {
        this.model[this.attribute] = [];
      }
    },
    loadSelected() {
      if (this.model[this.attribute]) {
        if (this.multiple) {
          this.selected = this.model[this.attribute]
        } else {
          this.selected = [this.model[this.attribute]]
        }
      } else {
        this.selected = []
      }
    }
  },
  watch: {
    "model.client": {
      handler(val){
        if (val) {
          if (val !== this.client) {
            this.client = val;
            this.selected = null;
            this.options = null;
            this.model[this.attribute] = this.multiple ? [] : null;
          }
        } else {
          this.selected = null;
          this.options = null;
        }
      }, deep: true
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  mounted() {
    this.loadSelected();
  },
  i18n: {
    messages: {
      vi: {
        default: 'Mặc định'
      },
      en: {
        default: 'Default'
      }
    }
  }
}
</script>

<style scoped>

</style>